exports = module.exports = require("../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wacg-wrapper .theme--light.v-sheet{background-color:#fff;border-color:#fff;color:rgba(0,0,0,.87)}#wacg-wrapper .theme--dark.v-sheet{background-color:#424242;border-color:#424242;color:#fff}#wacg-wrapper .v-sheet{display:block;border-radius:4px;position:relative;transition:box-shadow .28s cubic-bezier(.4,0,.2,1);will-change:box-shadow}#wacg-wrapper .v-sheet>:first-child:not(.v-btn):not(.v-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}#wacg-wrapper .v-sheet>:last-child:not(.v-btn):not(.v-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}#wacg-wrapper .v-sheet--tile{border-radius:0}", ""]);

// exports
